import {http} from "../utils/http";

export const postMapLocation = async (requestBody) => {
  try {
    const response = await http.post("/Map/locate", requestBody);
    return response?.data;
  } catch (error) {}
};

export const getMetersLocation = async (filters) => {
  try {
    return await http.get("/Map/meters-location", {
      params: filters,
    });
  } catch (error) {}
};

export const getAlarmsLocation = async (filters) => {
  try {
    return await http.get("/Map/alarms-location", {
      params: filters,
    });
  } catch (error) {}
};
